import { useState, useEffect } from "react";
import { MyDomain } from "../../../App";
import { useHistory, useParams } from "react-router-dom";

export default function GmailConnect() {
  const [connected, setConnected] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const history = useHistory();
  const { BossId } = useParams();

  // Fix trailing slash
  const API = MyDomain.endsWith("/") ? MyDomain.slice(0, -1) : MyDomain;

  // Get user from localStorage
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.id;

  useEffect(() => {
    if (userId) {
      checkStatus();
    }

    // Coming back from Google OAuth
    const params = new URLSearchParams(window.location.search);
    if (params.get("gmail") === "connected") {
      setConnected(true);
      // Clean URL
      window.history.replaceState(
        {},
        document.title,
        `/boss-main-page/${BossId}/invoices`,
      );
    }
  }, []);

  const checkStatus = async () => {
    try {
      const res = await fetch(`${API}/api/gmail/status/${userId}`);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const data = await res.json();
      setConnected(data.connected);
    } catch (err) {
      console.error("checkStatus error:", err.message);
      setError(`checkStatus: ${err.message}`);
    }
  };

  const connectGmail = async () => {
    try {
      const res = await fetch(`${API}/api/gmail/connect/${userId}`);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const data = await res.json();
      window.location.href = data.url;
    } catch (err) {
      console.error("connectGmail error:", err.message);
      setError(`connectGmail: ${err.message}`);
    }
  };

  const pullInvoices = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API}/api/gmail/pull-invoices/${userId}`);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const data = await res.json();
      setInvoices(data.invoices);
    } catch (err) {
      console.error("pullInvoices error:", err.message);
      setError(`pullInvoices: ${err.message}`);
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h3>📧 Gmail Invoices</h3>
      <p style={{ color: "#888" }}>User: {user?.name}</p>

      {error && (
        <div
          style={{
            background: "#fff0f0",
            border: "1px solid red",
            borderRadius: "8px",
            padding: "10px",
            marginBottom: "10px",
            color: "red",
            fontSize: "13px",
          }}
        >
          ❌ {error}
        </div>
      )}

      {!connected ? (
        <button
          onClick={connectGmail}
          style={{
            background: "#4285F4",
            color: "white",
            padding: "10px 20px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "15px",
          }}
        >
          🔗 Connect Gmail
        </button>
      ) : (
        <>
          <p style={{ color: "green" }}>✅ Gmail Connected</p>
          <button
            onClick={pullInvoices}
            style={{
              background: "#34A853",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "15px",
            }}
          >
            {loading ? "⏳ Loading..." : "📥 Pull Invoices"}
          </button>
        </>
      )}

      {invoices.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <h4>Found {invoices.length} invoices:</h4>
          {invoices.map((inv, i) => (
            <div
              key={i}
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "12px",
                marginBottom: "10px",
                background: "#f9f9f9",
              }}
            >
              <p>
                <strong>From:</strong> {inv.from}
              </p>
              <p>
                <strong>Subject:</strong> {inv.subject}
              </p>
              <p>
                <strong>Date:</strong> {inv.date}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
